/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTruckSideView: {
  name: 'truck-side-view';
  data: string;
} = {
  name: 'truck-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 1.5A1.5 1.5 0 0 0 .5 3v7a1.5 1.5 0 0 0 1.277 1.484 2 2 0 1 0 3.455.016H10c.232 0 .45-.053.647-.146a.502.502 0 0 0 .147.102 2 2 0 1 0 3.429.028A1.5 1.5 0 0 0 15.5 10V8.5a1.5 1.5 0 0 0-.6-1.2l-3.4-2.55V3A1.5 1.5 0 0 0 10 1.5H2Zm10.5 9H14a.5.5 0 0 0 .5-.5V8.5a.5.5 0 0 0-.2-.4L11.5 6v4c0 .175-.03.344-.085.5H12.5Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-10 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm7.5-2H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5Z" fill="currentColor"/></svg>`,
};
